export const bytesToStorageFormat = (locale: string, bytes: number | undefined, fractionSize = 2) => {
    if (!bytes || !isFinite(bytes)) return '-';
    if (!bytes) return '0 B';
    const units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB'];
    const number = Math.floor(Math.log(bytes) / Math.log(1024));
    const value = bytes / Math.pow(1024, Math.floor(number));

    // if (!fractionSize) {
    //     fractionSize = Math.max(2 - Math.floor(Math.log(value) / Math.log(10)), 0);
    // }

    return `${Intl.NumberFormat(locale, { maximumFractionDigits: fractionSize }).format(value)} ${units[number]}`;
};

export const diskSpaceToLocalized = (locale: string, d: string) => {
    if (!d || isNaN(parseFloat(d))) return d;
    const regexForChar = /([a-z,A-Z]+)/g;
    const char = d.match(regexForChar);
    if (!char) return Intl.NumberFormat(locale).format(parseFloat(d));
    return `${Intl.NumberFormat(locale).format(parseFloat(d))} ${char[0]}`;
};

export const stringNumberToBytes = (d: string): number => {
    const units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB'];
    const regexForChar = /([a-z,A-Z]+)/g;
    const char = d.match(regexForChar);
    if (!char) return parseFloat(d); // exception
    const num = parseFloat(d);
    const pow = units.indexOf(char[0]);
    if (pow < 0) return parseFloat(d); // exception
    return num * Math.pow(1024, pow);
};

export const sleep = (ms: number) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
};

const { electron } = window;

export const selectFolder = async (defaultPath = '') => {
    return new Promise((resolve, reject) => {
        electron.showOpenDialog({ defaultPath, properties: ['openDirectory'] }, (path: [string]) => {
            if (path && path.length > 0) resolve(path[0]);
            else reject();
        });
    });
};

export const replaceAll = (str: string, mapObj: object) => {
    var re = new RegExp(
        Object.keys(mapObj)
            .map((key) => key.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'))
            .join('|'),
        'gi'
    );

    return str.replace(re, (matched) => {
        return mapObj[matched as keyof object];
    });
};
